import { ENDPOINTS } from "@/constants/api/endpoints";
import { useApiQuery } from "../../hooks/use-api-query";
import { queryKeys } from "../../query-keys";
import { OriginResponse } from "@/types/origin";

export const useOrigins = () => {
  return useApiQuery<OriginResponse>(
    queryKeys.references.origins,
    ENDPOINTS.REFERENCES.ORIGINS,
    {},
    {
      staleTime: 30 * 60 * 1000, // 30 minutes - origins don't change frequently
      gcTime: 60 * 60 * 1000, // 1 hour
      refetchOnMount: false, // Use prefetched data, don't refetch on mount
      refetchOnWindowFocus: false, // Don't refetch on window focus for reference data
    }
  );
};
